module.exports = __webpack_public_path__ + "static/ps-lansman-f8716d0e7bd072c95e5b3ac6f7b9f3f6.png";